import {Tailwind} from '@wandb/weave/components/Tailwind';
import classNames from 'classnames';
import React, {FC} from 'react';

import {PremiumFeatureTooltip} from '../../util/accounts/pricing';

export interface TeamOrOrganizationRoleOptionProps {
  roleOption: RoleOption;
}

export type RoleOption = {
  text: string;
  value: string;
  description?: string | null;
  viewerCanInviteOtherAsRole?: boolean | null;
  isDisabled?: boolean | null;
} & (
  | {isPremiumOption: true; isPremiumFeatureDisabled: boolean}
  | {isPremiumOption: false}
);

export const TeamOrOrganizationRoleOption: FC<
  TeamOrOrganizationRoleOptionProps
> = ({roleOption}) => {
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col">
          <div
            className={classNames(
              'mr-auto',
              roleOption.isDisabled ? 'text-moon-800/40' : 'text-moon-800'
            )}>
            {roleOption.text}
          </div>
          {roleOption.description && (
            <div className="mt-5 text-moon-800/40">
              {roleOption.description}
            </div>
          )}
        </div>
        {roleOption.isPremiumOption && (
          <PremiumFeatureTooltip
            isPremiumFeatureDisabled={roleOption.isPremiumFeatureDisabled}
          />
        )}
      </div>
    </Tailwind>
  );
};
